// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"51e1a206","154":"0d120788","335":"66cfae66","453":"67e96d72"}[chunkId] + ".chunk.js";
};